import { MODELS, GAME_CONFIG } from '../../config';
import { LLMAdapter } from './LLMAdapter';
import { DeepSeekAdapter } from './DeepSeekAdapter';
import { QWQAdapter } from './QWQAdapter';
import { GeminiAdapter } from './GeminiAdapter';
import { DefaultAdapter } from './DefaultAdapter';
import { HunYuanAdapter } from './HunYuanAdapter';
import { OpenRouterAdapter } from './OpenRouterAdapter';

/**
 * LLM适配器工厂，用于创建不同的LLM适配器
 */
export class LLMAdapterFactory {
  /**
   * 根据模型ID创建对应的适配器
   * @param modelId 模型ID
   * @returns 对应的LLM适配器
   * @throws 如果找不到模型配置
   */
  static createAdapter(modelId: string): LLMAdapter {
    const modelConfig = MODELS.find(m => m.id === modelId);
    if (!modelConfig) {
      throw new Error(`未找到模型配置: ${modelId}`);
    }
    
    const debugMode = GAME_CONFIG.debugMode;
    
    // 首先根据供应商选择适配器
    if (modelConfig.vendor) {
      if (modelConfig.vendor === '302ai') {
        // 302ai供应商的特殊处理
        if (modelId.includes('gemini')) {
          return new GeminiAdapter(modelConfig, debugMode);
        }
      } else if (modelConfig.vendor === 'siliconflow') {
        // siliconflow的DeepSeek-V3
        console.log('创建DeepSeek适配器用于DeepSeek-V3');
        return new DeepSeekAdapter(modelConfig, debugMode);
      } else if (modelConfig.vendor === 'tencent') {
        // 腾讯云的混元模型
        console.log('创建HunYuan适配器用于腾讯混元模型');
        return new HunYuanAdapter(modelConfig, debugMode);
      } else if (modelConfig.vendor === 'openrouter') {
        // OpenRouter API
        console.log('创建OpenRouter适配器');
        return new OpenRouterAdapter(modelConfig, debugMode);
      }
    }
    
    // 根据模型ID选择适配器
    if (modelId.includes('deepseek') || modelId.includes('DeepSeek')) {
      return new DeepSeekAdapter(modelConfig, debugMode);
    } else if (modelId.includes('qwq')) {
      return new QWQAdapter(modelConfig, debugMode);
    } else if (modelId.includes('gemini')) {
      return new GeminiAdapter(modelConfig, debugMode);
    } else if (modelId.toLowerCase().includes('hunyuan')) {
      return new HunYuanAdapter(modelConfig, debugMode);
    }
    
    // 默认适配器
    return new DefaultAdapter(modelConfig, debugMode);
  }
} 